<template>

    <!-- new layout -->
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 class="p-d-flex p-ai-baseline p-jc-between">
                    <span>
                        <router-link v-if="client && client.key" :to="{ name: 'sites', params: { id: client.key } }">
                            {{ client.name }}
                        </router-link>
                        / Settings
                    </span>
                </h4>

                <div class="p-grid p-mt-2 p-mb-6">
                    <div class="p-col-12 p-lg-6">
                        <Toast />
                        <h4 style="margin-top: 0;">Company Logo</h4>
                        <img v-if="client.logo" class="client_logo" :src="client.logo.src" :alt="client.logo.name"
                            width="150" style="margin-bottom: 1rem;" />
                        <p v-else style="margin-bottom: 1rem;"><i>No Logo Selected</i></p>
                        <div style="margin-bottom: 1rem;">
                            <FileUpload v-if="client.logo" chooseLabel="Update" mode="basic" name="companyLogo"
                                @uploader="startUpload" :customUpload="true" ref="uploader" accept="image/*"
                                :maxFileSize="1000000" :fileLimit="1" />
                            <FileUpload v-else mode="basic" name="companyLogo" @uploader="startUpload"
                                :customUpload="true" ref="uploader" accept="image/*" :maxFileSize="1000000"
                                :fileLimit="1" />
                        </div>

                        <ul class="asset-details">
                            <h4>Company Colours</h4>
                            <li>
                                <span>Primary</span>
                                <div v-if="editSettings">
                                    <ColorPicker :defaultColor="client.primaryColour" v-model="colours.primary"
                                        style="margin-right:1rem" />
                                    <inputMask v-model="colours.primary" mask="******" slotChar="" />
                                </div>
                                <div v-else>
                                    <div class="colourpicker_placeholder"
                                        :style="{ 'background-color': '#' + client.primaryColour }"></div>
                                    <span class="colour_placeholder">#{{ client.primaryColour }}</span>
                                </div>
                            </li>

                            <li>
                                <span>Secondary</span>
                                <div v-if="editSettings">
                                    <ColorPicker :defaultColor="client.secondaryColour" v-model="colours.secondary"
                                        style="margin-right:1rem" />
                                    <inputMask v-model="colours.secondary" mask="******" slotChar="" />
                                </div>
                                <div v-else>
                                    <div class="colourpicker_placeholder"
                                        :style="{ 'background-color': '#' + client.secondaryColour }"></div>
                                    <span class="colour_placeholder">#{{ client.secondaryColour }}</span>
                                </div>
                            </li>

                            <li>
                                <span>Require SSO Auth</span>
                                <div style="display: flex; align-items: center; gap: 1rem;">
                                    <InputSwitch v-model="client.requireSSO" :disabled="!editSettings"/>
                                </div>
                            </li>

                            <!-- <li>
                                <p><strong>Email Notifications</strong></p>
                                <div style="display: flex; align-items: center; gap: 1rem;">
                                    <span>Check 1</span>
                                    <InputSwitch v-model="checked" />
                                </div>
                            </li> -->

                            <div class="site-actions">
                                <div class="p-d-flex p-jc-between">
                                    <Button v-if="!editSettings" label="Edit Settings" icon="pi pi-pencil"
                                        @click.prevent="editCompanySettings()" class="p-button-primary p-button" />
                                    <Button v-else label="Save Settings" icon="pi pi-save"
                                        @click.prevent="saveCompanySettings()" class="p-button-primary p-button" />
                                    <Button v-if="editSettings" label="Cancel" class="p-button-link"
                                        @click.prevent="cancelCompanySettings()" />
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db, storage } from '@/firebase';
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            colours: {
                primary: '',
                secondary: '',
            },
            checked: false,
            editSettings: false,
            requireSSO: false,
            // companyLogo: this.client.logo
        }
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.$route.params.client_id)
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
    // watch: {
    //     colours.primary() {
    //         // console.log(this.colours.primary)
    //     },
    //     colours.secondary() {
    //         // console.log(this.colours.secondary)
    //     }
    // },
    methods: {
        startUpload(logo) {
            // console.log(this)
            logo.files.forEach(file => {
                let uniqueName = Date.now() + '_' + file.name;
                this.convertToBase64(file, base64String => {
                    const storageRef = storage.ref('client/logo/' + this.client.key + '/' + uniqueName).putString(base64String, 'data_url');

                    storageRef.on(`state_changed`, snapshot => { }, error => {
                        // console.log(error.message)
                    }, () => {
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            const doc = {
                                src: url,
                                type: file.type,
                                name: file.name,
                                uniqueName: uniqueName,
                            }
                            this.$firestore.client.update({
                                logo: doc
                            });
                        });
                    });
                });
            });
            db.collection('logs').add({
                activity: 'Logo Updated',
                timestamp: new Date(),
                user: this.user.data.email,
                client_id: this.user.data.client.key
            }).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Logo Updated', life: 3000 });
            });
            this.$refs.uploader.clear();
        },
        convertToBase64(file, cb) {
            // FileReader function for read the file.
            var fileReader = new FileReader();
            var base64;
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                cb(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        },
        editCompanySettings() {
            this.editSettings = !this.editSettings;

            if (this.editSettings == true) {
                this.colours.primary = this.client.primaryColour,
                    this.colours.secondary = this.client.secondaryColour
            }
        },
        saveCompanySettings() {
            this.editSettings = !this.editSettings;

            this.$firestore.client.update({
                primaryColour: this.colours.primary,
                secondaryColour: this.colours.secondary,
                requireSSO: (this.client.requireSSO) ? this.client.requireSSO : false,
            }).then(() => {
                this.editSettings = false;

                db.collection('logs').add({
                    activity: 'Company settings updated',
                    timestamp: new Date(),
                    user: this.user.data.email,
                    client_id: this.user.data.client.key
                }).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Company settings updated', life: 3000 });
                });
            });

        },
        cancelCompanySettings() {
            this.editSettings = !this.editSettings;

            this.colours.primary = this.client.primaryColour,
                this.colours.secondary = this.client.secondaryColour
        }
    }
}
</script>

<style lang="scss">
.p-colorpicker-panel {
    background: #f8f9fa;
}

.asset-details {
    border-top: 1px solid #e9ecef;
    background: #f8f9fa;
    padding: 1rem;
    list-style: none;
    margin: 0;

    li {
        margin-bottom: 1rem;

        @media (max-width: 991px) {
            span {
                display: block;
            }

            span:nth-child(1) {
                font-weight: bold;
            }
        }

        @media (min-width: 991px) {
            display: flex;
            justify-content: space-between;
            position: relative;

            &:before {
                content: "";
                display: block;
                width: 100%;
                height: 1px;
                background: #e9ecef;
                position: absolute;
                top: 1.5rem;
                left: 0;
                z-index: 0;
            }
        }

        .warranty_switch {
            display: flex;
            align-items: center;
        }

        .colourpicker_placeholder {
            width: 2rem;
            height: 2rem;
            border-radius: 3px;
            border: 1px solid #ced4da;
            padding: .5rem;
            display: inline-block;
            margin-right: 1rem;
        }

        .colour_placeholder {
            position: relative;
            z-index: 2;
            background: #f8f9fa;
            font-size: 1.3rem;
            line-height: 2.5rem;
            text-transform: uppercase;
        }

        >div {
            position: relative;
            background: #f8f9fa;
            padding-left: 1rem;
            min-width: 240px;
            display: flex;
            align-items: center;
        }

        .p-fileupload,
        .client_logo {
            z-index: 2;
            position: relative;
        }

        .p-colorpicker {
            +.p-inputtext {
                text-transform: uppercase;
            }
        }

        .client_logo {}

        >span,
        input {
            position: relative;
            z-index: 2;
            background: #f8f9fa;
        }

        >span {
            font-size: 1.3rem;
            line-height: 2.5rem;
        }

        >span:nth-child(1) {
            padding-right: 1rem;
        }

        >span:nth-child(2) {
            padding-left: 1rem;
            width: 50%;
        }

        .field {
            width: 100%;

            input {
                width: 100%;
            }

        }
    }
}
</style>
